













































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { WITHDRAW_URL } from '../assets/js/urls';
const axios = require('../axios/index.js').default;

@Component
export default class DialogWithdraw extends Vue{
    @Prop() readonly amount: string | undefined;
    @Prop() readonly phone: string | undefined;
    @Prop() readonly fromVal: string | undefined;
    
    dialogType: string = "normal";    // normal, success, fail
    failMsg: string = "";

    // computed 属性
    get loginStatus(): boolean {
        return this.$store.state.isLogin;
    }

    // 提交
    submitFn() {
        let self = this;
        // console.log(self.amount, self.phone, self.fromVal)

        let opts = {
            provider: self.fromVal,
            amount: self.amount,
            phone: self.phone
        }
        
        // console.log('opts = ', JSON.stringify(opts));
        self.$as.send('click_submit_withdraw_btn_DialogWithdraw');
        if(!self.loginStatus) {
            self.$toasted.show("Login first please");
            return;
        }

        axios({
            method: 'post',
            url: WITHDRAW_URL,
            data: JSON.stringify(opts),
        }).then((resp:any) => {
            // console.log('withdraw resp:', resp);
            let resData = resp.data;
            if(resData.status.code == 0) {
                // self.dialogType = 'success';
                self.$as.send('submit_withdraw_successful_DialogWithdraw');
                self.$bus.$emit('get-config');
                self.$router.push('/withdraw-success');
            }else{
                self.$as.send('submit_withdraw_failed_DialogWithdraw');
                self.dialogType = 'fail';
                self.failMsg = resData.status.reason;
            }
        })
        .catch((e:any) => {
            // console.log('err: ', e);
            self.$as.send('submit_withdraw_failed_DialogWithdraw');
            self.failMsg = "Withdraw failed";
            self.dialogType = 'fail';
        })
    }

    // 关闭 Dialog
    @Emit('dialog-show')
    private closeSuccessDialog() {
        this.$as.send('click_ok_btn_successful_DialogWithdraw');
    }

    // 关闭 Dialog
    @Emit('dialog-show')
    private closeFailedDialog() {
        this.$as.send('click_ok_btn_failed_DialogWithdraw');
    }

    // 关闭 Dialog
    @Emit('dialog-show')
    private closeDialog() {
        this.$as.send('click_close_btn_DialogWithdraw');
        return false;
    }
}
